<template>
  <block
    component-name="block-launcher-cta-double"
    body-class="flex flex-col laptop:flex-row justify-center laptop:items-stretch gap-x-ui gap-y-2xl"
  >
    <template v-slot:default="blockData">
      <card-cta
        :overline="$attrs.data.body.a.overline"
        :title="$attrs.data.body.a.title"
        :text="$attrs.data.body.a.text"
        :button="$attrs.data.body.a.button"
        :asset="{
          ...$attrs.data.body.a.asset,
          sizes: sizes,
          loading: blockData?.loading || 'eager',
        }"
        :force-vertical-media="isLaptop"
        class="w-full laptop:w-1/2"
      />

      <card-cta
        :overline="$attrs.data.body.b.overline"
        :title="$attrs.data.body.b.title"
        :text="$attrs.data.body.b.text"
        :button="$attrs.data.body.b.button"
        :asset="{
          ...$attrs.data.body.b.asset,
          sizes: sizes,
          loading: blockData?.loading || 'eager',
        }"
        :force-vertical-media="isLaptop"
        class="w-full laptop:w-1/2"
      />
    </template>
  </block>
</template>

<script setup>
const sizes = ref({
  base: 600,
  phablet: 950,
  tablet: 500,
  laptop: 300,
  desktop: 400,
  extdesktop: 500,
});

const isLaptop = useMediaQuery("(min-width: 1272px)");
</script>
